import React from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import logo from '../../image/logo.png';
import './Navigations.css';
const Navigations = () => {
    return (
        <div>
            <Navbar collapseOnSelect expand="lg" variant="dark" className="header-color">
                <Container className="header-menu">
                    <Navbar.Brand href="#home"><img className="img-fluid" src={logo} alt="" /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav " />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">


                        </Nav>
                        <Nav className="text-white header-navigation">
                            <NavLink to="/home">Home</NavLink>
                            <NavLink to="/AboutUs">AboutUs</NavLink>
                            <NavLink to="/Service">Service</NavLink>
                            <NavLink to="/Contact">Contact</NavLink>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default Navigations;